import React from "react";
import { useSelector } from 'react-redux'
import _ from 'lodash'
import RenderEmployeeList from "../../_functions/EmployeeRenders";
import selectFavourites from 'services/redux/data/selectors/selectFavourites'

const HomeBookSelectCoworkerIndexTabFavourites = () => {
	
	const _favourites = useSelector( selectFavourites );
	
	return (
		<RenderEmployeeList
			employees={ _.filter( _favourites, { is_favourite: 'yes' } ) }
		/>
	)
}

export default HomeBookSelectCoworkerIndexTabFavourites;
